export const ensureBearerToken = accessToken => {
  const bearerPrefix = "Bearer ";
  if (typeof accessToken === "string" && !accessToken.startsWith(bearerPrefix)) {
    return bearerPrefix + accessToken;
  }
  return accessToken;
};

export const parseJwt = token => {
  try {
    // Remove 'Bearer ' prefix if present
    const base64Url = token.startsWith("Bearer ")
      ? token.slice(7).split(".")[1]
      : token.split(".")[1];

    // Replace URL-safe characters and decode Base64
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const decodedPayload = JSON.parse(atob(base64)); // Decode Base64 and parse JSON
    return decodedPayload; // Return the extracted values
  } catch (error) {
    console.error("Invalid token:", error.message);
    return null;
  }
};

/**
 * Gets authentication token from cookie
 * @returns {string|null} - Authentication token or null if not found
 */
export const getAuthTokenFromCookie = () => {
  try {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith("auth_token=")) {
        const token = trimmedCookie.substring("auth_token=".length);

        // Clear the cookie if needed
        document.cookie = "auth_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return token;
      }
    }
    return null;
  } catch (error) {
    console.error("Error reading authentication token:", error);
    return null;
  }
};
export const getrefreshTokenFromCookie = () => {
  try {
    const cookies = document.cookie.split(";");
    for (const cookie of cookies) {
      const trimmedCookie = cookie.trim();
      if (trimmedCookie.startsWith("refresh_token=")) {
        const token = trimmedCookie.substring("refresh_token=".length);

        // Clear the cookie if needed
        document.cookie = "refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        return token;
      }
    }
    return null;
  } catch (error) {
    console.error("Error reading refresh token:", error);
    return null;
  }
};
